<button
  class="c-button"
  [ngClass]="buttonType"
  [class.disabled]="disabled"
  [disabled]="disabled"
  (click)="onClick($event)">
  <img [src]="buttonIcon" />
  <span>{{ buttonText | translate }}</span>
</button>
